<template>
  <button class="floating-search-button" @click="showSearchModal">
    <img class="floating-search-button__icon" :src="iconFilter" width="24" height="23" alt="絞り込む" />
    <span class="floating-search-button__text">絞り込む</span>
  </button>
</template>

<script setup lang="ts">
import iconFilter from '@/public/icons/icon-filter.svg'
import { useMainStore } from '@/store'

const store = useMainStore()

const showSearchModal = () => {
  store.SET_STATE({ key: 'event_search_modal', value: 'search' })
}
</script>
<style lang="scss" scoped>
.floating-search-button {
  position: fixed;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: hsla(39, 100%, 63%, 1);
  border-style: none;
  border-radius: 50%;
  width: 64px;
  height: 64px;
}

.floating-search-button:active {
  background-color: hsla(39, 100%, 50%, 1);
}

.floating-search-button__text {
  font-size: 10px;
  font-weight: bold;
  color: $black-1a;
}

.image-placeholder {
  width: 24px;
  height: 23px;
}
</style>
